import { render, staticRenderFns } from "./AppColorPalette.vue?vue&type=template&id=ac0ffc4e&scoped=true&"
import script from "./AppColorPalette.vue?vue&type=script&lang=js&"
export * from "./AppColorPalette.vue?vue&type=script&lang=js&"
import style0 from "./AppColorPalette.vue?vue&type=style&index=0&id=ac0ffc4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Documents/GitHub/cis-planning/survey-planning.front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0ffc4e",
  null
  
)

export default component.exports